import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../common/Button';
import TransactionForm from '../TransactionForm/TransactionForm';

const WalletDashboard = ({ wallet, onTransaction, loading }) => {
  const formatBalance = (balance) => {
    return parseFloat(balance).toFixed(4);
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <div className="max-w-4xl mx-auto space-y-6">
      {/* Wallet Info Card */}
      <div className="bg-white p-6 rounded-lg shadow-lg">
        <div className="flex justify-between items-start mb-4">
          <div>
            <h1 className="text-3xl font-bold text-gray-800">{wallet.name}</h1>
            <p className="text-gray-600">
              Created on {formatDate(wallet.date)}
            </p>
          </div>
          <div className="text-right">
            <p className="text-sm text-gray-600">Current Balance</p>
            <p className="text-3xl font-bold text-green-600">
              ₹{formatBalance(wallet.balance)}
            </p>
          </div>
        </div>

        <div className="flex justify-between items-center">
          <div className="text-sm text-gray-500">Wallet ID: {wallet.id}</div>
          <Link to="/transactions">
            <Button variant="secondary">View Transactions</Button>
          </Link>
        </div>
      </div>

      {/* Transaction Form */}
      <div className="bg-white p-6 rounded-lg shadow-lg">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Make a Transaction
        </h2>
        <TransactionForm onTransaction={onTransaction} loading={loading} />
      </div>
    </div>
  );
};

export default WalletDashboard;
